import { Configure, Index, InstantSearch } from 'react-instantsearch';
import type { ISearchOverlayTitles } from '@/components/SearchOverlay/types';
import { SuggestionsIndex } from '@/components/Instantsearch/components/SuggestionsIndex';
import { useEffect, useState } from 'react';
import getSearchClient from 'server/repository/algolia/client';

interface RecipeSearchResultsProps {
  searchOverlayData?: ISearchOverlayTitles;
  slug: string;
}

const HITS_PER_PAGE_RECIPE = 12;

/**
 * Process slug for search query
 * 1. Remove .html extension (case insensitive)
 * 2. Replace hyphens with spaces
 */
const processSlugForSearch = (slug: string): string => {
  let processedSlug = slug.replace(/\.html$/i, '');

  processedSlug = processedSlug.replace(/-/g, ' ');

  return processedSlug;
};

export const RecipeSearchResults = ({ searchOverlayData, slug }: RecipeSearchResultsProps) => {
  const [searchOverlayDataExtended, setSearchOverlayDataExtended] = useState(searchOverlayData);

  useEffect(() => {
    if (searchOverlayData && !searchOverlayDataExtended?.searchClient) {
      const algoliaClient = getSearchClient();
      setSearchOverlayDataExtended({
        ...searchOverlayData,
        searchClient: algoliaClient,
      });
    }
  }, [searchOverlayData]);

  const shouldSkipSearch = slug === '[slug]';

  if (!searchOverlayDataExtended?.searchClient || !searchOverlayDataExtended?.indices?.recipes) {
    return null;
  }

  if (shouldSkipSearch) {
    return null;
  }

  const searchQuery = processSlugForSearch(slug);

  return (
    <InstantSearch
      searchClient={searchOverlayDataExtended.searchClient}
      indexName={searchOverlayDataExtended.indices.recipes}
      stalledSearchDelay={200}
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}
      insights={true}
    >
      <Configure query={searchQuery} hitsPerPage={HITS_PER_PAGE_RECIPE} />
      <Index indexName={searchOverlayDataExtended.indices.recipes}>
        <SuggestionsIndex
          searchValue={searchQuery}
          objectType="RECIPES"
          searchData={{
            copy: searchOverlayDataExtended?.copy,
          }}
          indexName={searchOverlayDataExtended.indices.recipes}
          numberOfAlreadyViewedHitsBeforeThisIndex={0}
        />
      </Index>
    </InstantSearch>
  );
};
